import { InputHTMLAttributes, ReactNode } from 'react';
import { Path, useFormContext } from 'react-hook-form';

import ErrorMessage from '../ErrorMessage/ErrorMessage';
import Input from 'components/Input/Input';

type FormInputPropsT<FormValuesT> = InputHTMLAttributes<HTMLInputElement> & {
  name: Path<FormValuesT> | string;
  label?: string | ReactNode;
  isRequired?: boolean;
};

const FormInput = <FormValuesT,>({ name, ...restProps }: FormInputPropsT<FormValuesT>) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();

  return (
    <>
      <Input {...register(name)} {...restProps} />
      {errors[name] && <ErrorMessage error={errors[name]?.message as Path<FormValuesT>} />}
    </>
  );
};

export default FormInput;
